module.exports = __webpack_public_path__ + "static/media/Enjin-Coin_ENJ.d5456498.png";